import { render, staticRenderFns } from "./employees-settings-open-registration.vue?vue&type=template&id=d6dac4fc&"
import script from "./employees-settings-open-registration.vue?vue&type=script&lang=js&"
export * from "./employees-settings-open-registration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports